import { Grid, Heading, Text } from "@chakra-ui/react";
import { Reveal } from "@/components";
import { PRICING_HERO } from "@/content";

export const PricingHero = () => (
  <Grid
    as="section"
    maxW="maxw"
    mx="auto"
    px="pad"
    pt="clamp(48px, 7vw, 104px)"
    pb="clamp(40px, 5vw, 72px)"
    gap="22px"
    justifyItems="center"
    textAlign="center"
  >
    <Reveal>
      <Text variant="eyebrowBrand">{PRICING_HERO.eyebrow}</Text>
    </Reveal>
    <Reveal>
      <Heading as="h1" variant="section" maxW="16ch">
        {PRICING_HERO.title}
      </Heading>
    </Reveal>
    <Reveal>
      <Text variant="lede" maxW="54ch">
        {PRICING_HERO.lede}
      </Text>
    </Reveal>
  </Grid>
);
